function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, React.createElement("path", {
  d: "m13.732 2.508-2.169-2.169a.916.916 0 0 0 -1.3 0l-4.77 4.83-.661 3.031a.917.917 0 0 0 1.09 1.09l3.035-.661 4.778-4.829a.915.915 0 0 0 -.003-1.292z"
}), React.createElement("path", {
  d: "m11.99 8.81h-.408a1.015 1.015 0 0 0 -1 1.011v1.689h-8.163v-8.161h1.687a1.011 1.011 0 0 0 1.01-1.01v-.408a1.013 1.013 0 0 0 -1.01-1h-3.1a1 1 0 0 0 -.976.845 1.069 1.069 0 0 0 -.03.156v10.987a1 1 0 0 0 .266.669c.012.013.017.031.03.044s.027.016.039.026a1 1 0 0 0 .674.27h10.981a1 1 0 0 0 .669-.266c.013-.012.032-.017.044-.03s.018-.031.03-.044a1 1 0 0 0 .267-.668v-3.1a1.011 1.011 0 0 0 -1.01-1.01z"
}));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/window-filled.792ac407.svg";
export { SvgComponent as ReactComponent };